import React, { useState } from 'react';
import { twMerge } from 'tailwind-merge';
import Avatar from 'flow/components/ui-components/Avatar';
import Icon from 'flow/components/ui-components/Icon';
import { useAppSelector } from 'flow/hooks/useRedux';
import {
    selectQueueActiveProfileAvailable,
    selectQueueHasOmniSupport,
} from 'flow/selectors/queue-selectors';
import { QueueKey } from 'flow/types/EntityKeys';
import SectionAgentsLoggedIn from './QueueRow/SectionAgentsLoggedIn';
import SectionAgentsSoonLoggedIn from './QueueRow/SectionAgentsSoonLoggedIn';
import SectionWaitingQueueItems from './QueueRow/SectionWaitingQueueItems';
import QueueRowWaitTime from './sub-components/QueueRowWaitTime';
import SupervisorQueueDescriptionInfo from './SupervisorQueueDescriptionInfo';
import SupervisorQueueRowMenu from './sub-components/SupervisorQueueRowMenu';

interface Props {
    queueKey: QueueKey;
}

const SupervisorQueueRow = ({ queueKey }: Props) => {
    const [itemIsActive, setItemIsActive] = useState(false);
    const activeProfileAvailable = useAppSelector((state) =>
        selectQueueActiveProfileAvailable(state, queueKey),
    );
    const queueIsOmniType = useAppSelector((state) =>
        selectQueueHasOmniSupport(state, queueKey),
    );

    return (
        <div
            key={`fragment-queue-${queueKey}`}
            className="inset-x-0 m-auto mb-1.5 flex max-w-2xl ps-3 pe-1"
        >
            <div className="hover:shadow-base group box-border flex w-full flex-col justify-between gap-3 rounded-sm bg-white px-3 py-3 shadow-xs dark:bg-gray-100">
                <div className="flex h-10 flex-row items-center justify-between">
                    <div className="flex items-center gap-2 overflow-x-hidden">
                        <Avatar className="bg-pbx-huntgroup">
                            <Icon
                                iconKey={
                                    queueIsOmniType
                                        ? 'omni-queue'
                                        : 'queuelogin'
                                }
                                className="text-iconOnBrand"
                            />
                        </Avatar>
                        <SupervisorQueueDescriptionInfo queueKey={queueKey} />
                    </div>
                    <div className="flex items-center justify-between gap-2">
                        <QueueRowWaitTime queueKey={queueKey} />
                        <div
                            className={twMerge(
                                'items-center text-gray-800',
                                itemIsActive
                                    ? 'flex'
                                    : 'sr-only-until-hover-or-focus flex',
                            )}
                        >
                            <SupervisorQueueRowMenu
                                queueKey={queueKey}
                                setActive={setItemIsActive}
                            />
                        </div>
                    </div>
                </div>
                {activeProfileAvailable ? (
                    <div className="ms-12 flex h-15 flex-col flex-wrap justify-around">
                        <SectionWaitingQueueItems queueKey={queueKey} />
                        <SectionAgentsLoggedIn queueKey={queueKey} />
                        <SectionAgentsSoonLoggedIn queueKey={queueKey} />
                    </div>
                ) : null}
            </div>
        </div>
    );
};

export default React.memo(SupervisorQueueRow);
